import { Card } from "react-bootstrap";
import starMemberBorder from "../../assets/images/profile/starMemberBorder.png";
import { useNavigate } from "react-router-dom";
import default_man from "../../assets/images/profile/default-man.png";
import default_woman from "../../assets/images/profile/default-woman.png";

const MemberCard = ({ member, cardActions }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/member-profile/${member.user_id}`, {
      state: { member },
    });
  };

  return (
    <div
      onClick={handleClick}
      className="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center align-items-center hover-shadow"
    >
      <Card
        style={{
          position: "relative",
          backgroundColor: "#5A427F",
          borderRadius: "1rem",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          marginTop: "1rem",
          height: "300px",
          width: "200px",
          cursor: "pointer",
          color: "#fff",
        }}
      >
        {/* Online Status Indicator */}
        <div
          className="online-status translate-middle p-2 rounded-circle"
          style={{
            zIndex: 1,
            margin: "8px",
            backgroundColor:
              member.user_status === "online" ? "#00ff00" : "gray",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          <span className="visually-hidden">Online status</span>
        </div>

        <Card.Body className="d-flex flex-column align-items-center justify-content-center gap-3 px-2">
          {/* Profile Image */}
          <div
            className="position-relative"
            style={{
              width: "100px",
              height: "100px",
            }}
          >
            <img
              src={
                member.profile_image ||
                (member.gender === "ذكر" ? default_man : default_woman)
              }
              className="rounded-circle w-100 h-100"
              style={{
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
              alt="profile"
            />
            {member.role === "star" && (
              <img
                src={starMemberBorder}
                className="w-100 h-100"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 0,
                  transform: "scale(1.5)",
                }}
                alt="star border"
              />
            )}
          </div>

          {/* Name and Age */}
          <Card.Title
            className="d-flex justify-content-between align-items-start w-100"
            style={{
              fontSize: "0.9rem",
              marginTop: "0.5rem",
              paddingBottom: "0.5rem",
              borderBottom: "1px solid rgba(255,255,255,0.2)",
              minHeight: "40px",
            }}
          >
            <div
              style={{
                wordBreak: "break-word",
                whiteSpace: "normal",
                maxWidth: "120px",
              }}
            >
              {member.user_name}
            </div>
            <div>{member.age}</div>
          </Card.Title>

          {/* Location and Status */}
          <div className="d-flex justify-content-between w-100">
            {[
              { icon: "icofont-location-pin", text: member.country },
              { icon: "icofont-home", text: member.social_status },
            ].map((item, index) => (
              <div
                key={index}
                className="d-flex flex-column align-items-center"
                style={{
                  flex: 1,
                  padding: "0 0.25rem",
                  fontSize: "0.75rem",
                  textAlign: "center",
                }}
              >
                <i
                  className={`${item.icon} mb-1`}
                  style={{ fontSize: "1.1rem" }}
                />
                <span
                  style={{
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    lineHeight: "1.2",
                  }}
                >
                  {item.text}
                </span>
              </div>
            ))}
          </div>

          {cardActions && <InterstsButton />}
        </Card.Body>
      </Card>
    </div>
  );
};

export default MemberCard;
